import {PLAYER_BONUS_TYPES} from "./playerBonus";

/**
 * Числа уровней бонуса ДО 29.10 (main dd89d6b2) — неизменная копия, не
 * править. Тогда доход бонуса был только фиксированным, пока у игрока есть
 * хотя бы 1 город (coinsIncomeBonus; у «божества» еще winPointsIncomeBonus), и
 * был уровень SMALL. Следующие числа — «только за города», ниже.
 *
 * По ним проигрываются старые записи, где числа не зафиксированы в самом
 * игроке, — локальные партии: в их LOAD_STATE нет метки
 * isPlayerBonusPerCityRule (см. checkIfPlayerBonusPerCityRule), и
 * createPlayersState кладет игроку с бонусом эти числа в bonusConfig. Записи с
 * зафиксированными числами (явные боты, бонус лобби) таблица не трогает — их
 * bonusConfig уже в прежней форме.
 */
export const LEGACY_PLAYER_BONUS_CONFIG = {
  [PLAYER_BONUS_TYPES.NONE]: {
    coinsIncomeBonus: 0,
    constructionActionsBonus: 0,
    startingCoinsBonus: 0,
  },
  [PLAYER_BONUS_TYPES.SMALL]: {
    coinsIncomeBonus: 1,
    constructionActionsBonus: 0,
    startingCoinsBonus: 3,
  },
  [PLAYER_BONUS_TYPES.MEDIUM]: {
    coinsIncomeBonus: 2,
    constructionActionsBonus: 1,
    startingCoinsBonus: 5,
  },
  [PLAYER_BONUS_TYPES.BIG]: {
    coinsIncomeBonus: 3,
    constructionActionsBonus: 2,
    startingCoinsBonus: 8,
  },
  [PLAYER_BONUS_TYPES.LARGE]: {
    coinsIncomeBonus: 6,
    constructionActionsBonus: 3,
    startingCoinsBonus: 10,
  },
  [PLAYER_BONUS_TYPES.GREAT]: {
    coinsIncomeBonus: 10,
    constructionActionsBonus: 3,
    startingCoinsBonus: 20,
  },
  [PLAYER_BONUS_TYPES.DIVINE]: {
    coinsIncomeBonus: 10,
    constructionActionsBonus: 3,
    startingCoinsBonus: 20,
    winPointsIncomeBonus: 3,
    d6MinRoll: 6,
  },
};

// Прежние числа уровня или null — уровень неизвестен
export const getLegacyPlayerBonusConfig = (bonusType) => LEGACY_PLAYER_BONUS_CONFIG[bonusType] || null;

/**
 * Числа уровней «доход бонуса только за города» (main 19795091 … 0bc16d73, 29.10)
 * — неизменная копия, не править. Потом владелец перенес по монете дохода за
 * город в фиксированную прибавку, одинаковую у всех уровней, и поменял
 * стартовые монеты (configs/playerBonus).
 *
 * Метка для записей не нужна: с введения дохода за города каждая запись, где у
 * игрока есть бонус, несет его числа в самом игроке (bonusConfig явных ботов,
 * бонуса лобби и, с того же коммита, локальных партий — prepareLocalMatchPlayers).
 * Таблица нужна тому, что сверяет числа по уровню:
 *  - сервер принимает от клиента локальной партии и эти числа
 *    (getVerifiedLocalBonusConfig) — клиент мог начать партию до обновления;
 *  - шкала поведения бонусных ботов (getBotBonusIntensity) настроена на этих
 *    числах и сводит к ним уровень с любыми числами — текущими и прежними.
 */
export const PER_CITY_ONLY_PLAYER_BONUS_CONFIG = {
  [PLAYER_BONUS_TYPES.NONE]: {
    coinsIncomePerCityBonus: 0,
    constructionActionsBonus: 0,
    startingCoinsBonus: 0,
  },
  [PLAYER_BONUS_TYPES.MEDIUM]: {
    coinsIncomePerCityBonus: 1,
    constructionActionsBonus: 1,
    startingCoinsBonus: 3,
  },
  [PLAYER_BONUS_TYPES.BIG]: {
    coinsIncomePerCityBonus: 2,
    constructionActionsBonus: 2,
    startingCoinsBonus: 6,
  },
  [PLAYER_BONUS_TYPES.LARGE]: {
    coinsIncomePerCityBonus: 3,
    constructionActionsBonus: 3,
    startingCoinsBonus: 8,
  },
  [PLAYER_BONUS_TYPES.GREAT]: {
    coinsIncomePerCityBonus: 4,
    constructionActionsBonus: 3,
    startingCoinsBonus: 15,
  },
  [PLAYER_BONUS_TYPES.DIVINE]: {
    coinsIncomePerCityBonus: 5,
    constructionActionsBonus: 3,
    startingCoinsBonus: 15,
    winPointsIncomePerCityBonus: 1,
    d6MinRoll: 6,
  },
};

// Числа уровня «только за города» или null — уровень неизвестен
export const getPerCityOnlyPlayerBonusConfig = (bonusType) => PER_CITY_ONLY_PLAYER_BONUS_CONFIG[bonusType] || null;
